import type { AllRouteEndpoints } from "../routeTypes";

/**
 * Queries to go stale after `update_enabled_state` succeeds. The React mutation adapter applies this
 * list for the campaigns list page; the campaign page's Knockout stop/resume toggle posts the same
 * endpoint through raw `$.ajax` and applies it by hand
 * (`dashboard/app/assets/js/dashboard/view_models/campaigns.ko.js.coffee`, `toggleCampaignEnabled`),
 * so keep both consumers in mind when editing it.
 */
export const engagementCampaignsAppGroupIdUpdateEnabledStateCacheKeys: AllRouteEndpoints[] = [
  "/engagement/campaigns_data_v2",
  "/engagement/campaigns_data",
  // The campaign page's React analytics footer reads `enabled` from this query, so it has to go
  // stale with the list queries or the footer keeps the pre-toggle button set until a full page
  // refresh.
  "/engagement/campaign_data(/:campaign_id)",
  "/engagement/:app_group_id/feature_flags/:rollout_id/experiment_usage",
  "/engagement/feature_flag_rollouts_data",
  "/engagement/:app_group_id/feature_flags/:rollout_id/dependencies",
  "/engagement/:app_id/feature_flags_eligibility/:user_id/:device_id",
];
